import React, { useEffect } from 'react';
import WhyHRMSSection from './WhyHRMSSection';
import Section from '../../Section';
import HRSection from './HRSection';
import a2 from "../../Images/a2.png";
import a23 from "../../Images/a23.jpg";
import hrbg from "../../Images/bg/hrbg.jpg";
import about from "../../Images/about.png";
import HeroStyle2 from '../../Hero/HeroStyle2';
import funfact from "../../Images/funfact.jpeg";
import { pageTitle } from '../../../helpers/PageTitle';
import FunFactSection from '../../Section/FunFactSection';
import AboutSectionStyle3 from '../../Section/AboutSection/AboutSectionStyle3';
import BannerSectionStyle2 from '../../Section/BannerSection/BannerSectionStyle2';
import generalvideo from "../../Images/generalvideo.mp4"
import DepartmentSectionStyle6 from '../../Section/DepartmentSection/DepartmentSectionStyle6';
import AppointmentSectionStyle2 from '../../Section/AppointmentSection/AppointmentSectionStyle2';
import FeaturesSectionStyle5 from '../../Section/FeaturesSection/FeaturesSectionStyle5';

const featureListData = [
    {
        iconUrl: process.env.PUBLIC_URL + '/images/home_4/compassion.svg',
        title: 'Employee Information System (EIS) ',
        subTitle:
            'Centralized digital profiles of all staff, including doctors, nurses, technicians, admin,' +
            'and visiting consultants. Manage documents, contracts, certifications, and lifecycle events ' +
            '— all from one dashboard.',
    },
    {
        iconUrl: process.env.PUBLIC_URL + '/images/home_4/excellence.svg',
        title: 'Attendance & Shift Management ',
        subTitle:
            'Designed for hospitals with 24/7 duty rotations.' +
            ' Biometric / QR / RFID integration ,Duty roster scheduling ,' +
            'Auto - shift allocation for nurses and paramedics ' +
            ' Real - time attendance dashboards ',
    },
    {
        iconUrl: process.env.PUBLIC_URL + '/images/home_4/integrity.svg',
        title: ' Payroll & Compensation ',
        subTitle: `Fully automated payroll processing with: Salary templates, Statutory deductions (PF, ESI, TDS) 
         , Overtime calculations , Night-shift allowances , Auto-generated payslips `,
    },
    {
        iconUrl: process.env.PUBLIC_URL + '/images/home_4/respect.svg',
        title: 'Leave & Holiday Management ',
        subTitle:
            'Instant leave requests, approvals, tracking, and customizable leave rules for healthcare ' +
            'environments with continuous operations. ',
    },
    {
        iconUrl: process.env.PUBLIC_URL + '/images/home_4/teamwork.svg',
        title: ' Recruitment & Onboarding',
        subTitle:
            'Digitized hiring workflow for doctors, medical staff, and support teams.Job posting,' +
            'Application screening ,Interview tracking , Offer letters , Digital onboarding',
    },
    {
        iconUrl: process.env.PUBLIC_URL + '/images/home_4/compassion.svg',
        title: ' Performance Management ',
        subTitle:
            'Set KPIs for all staff, track performance, conduct appraisals, and analyze workforce ' +
            'productivity,through dashboards and scorecards.',
    },
    {
        iconUrl: process.env.PUBLIC_URL + '/images/home_4/excellence.svg',
        title: 'Training & Compliance Management',
        subTitle:
            'Essential for Emirati healthcare requirements.Track: NABH-related training ,' +
            'Clinical certifications , Mandatory skill upgradations, Documentation renewal alerts',
    },
    {
        iconUrl: process.env.PUBLIC_URL + '/images/home_4/integrity.svg',
        title: 'Employee Self-Service Portal (ESS)',
        subTitle: `A mobile-ready portal for staff to: Check shifts , Apply leave , View payslips ,
         Update profiles ,Track attendance , Access documents `,
    },
];

const departmentData = [
    {
        title: 'Paperless HR Operations',
        subTitle:
            ' No more manual registers',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/department_icon_1.svg',
    },
    {
        title: 'Unified Workforce Data',
        subTitle:
            ' One source of truth  Departement',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/department_icon_1.svg',
    },
    {
        title: 'Automated Workflows',
        subTitle:
            ' Payroll, attendance, and approvals run themselves ',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/department_icon_1.svg',
    },
    {
        title: 'Real-Time HR Analytics ',
        subTitle:
            'Turn workforce data into decisions',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/department_icon_1.svg',
    },
    {
        title: 'Role-Based Access',
        subTitle:
            'Secure HR operations with audit logs',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/department_icon_1.svg',
    },
    {
        title: ' Ideal for Large Hospitals  ',
        subTitle:
            'Handle 500–10,000+ staff effortlessly',
        iconUrl: process.env.PUBLIC_URL + '/images/home_2/department_icon_1.svg',
    },
];
const brandData = [
    {
        imgUrl: '/images/brand_1.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_2.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_3.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_4.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_5.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_6.png',
        imgAlt: 'Brand',
    },
    {
        imgUrl: '/images/brand_7.png',
        imgAlt: 'Brand',
    },
];

const funFactData = [
    { number: '15+', title: 'Years of experience' },
    { number: '1.6 Cr', title: 'Patient Registration' },
    { number: '700000+', title: 'Transactions per day.' },
    { number: '300+', title: 'Hospitals,Diagnostic Centers and Pharmacies Customers' },
    { number: '5+', title: 'Countries Customers' },
];

export default function HRSolutions() {
    pageTitle('Home V2');

    // Preload the background image for faster loading
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = hrbg;
        link.fetchPriority = 'high';
        document.head.appendChild(link);

        // Also preload the image in browser cache
        const img = new Image();
        img.src = hrbg;

        return () => {
            if (document.head.contains(link)) {
                document.head.removeChild(link);
            }
        };
    }, []);

    return (
        <>
            <HeroStyle2
                title="Human Resource Management System"
                subTitle="A comprehensive Human Resource Management System that simplifies, automates, and 
accelerates all HR workflows — from onboarding to payroll — built for hospitals, clinics, and 
healthcare networks across UAE."
                bgUrl={hrbg}
                imgUrl={process.env.PUBLIC_URL + "/images/home_2/patents.png"}
            // btnText="Doc Choice"
            // btnUrl="/"
            />
            <Section topMd={175} topLg={125} topXl={85}>
                <FunFactSection
                    bgUrl={funfact}
                    data={funFactData}
                />
            </Section>

            {/* <Section bottomMd={125} bottomLg={125} bottomXl={85}>
        <DepartmentSectionStyle4
          sectionTitle="For Your Health"
          sectionTitleUp="OUR DEPARTMENTS"
          data={departmentData}
        />
      </Section> */}
            {/* <Section
        className="cs_bg_filed"
        style={{ backgroundImage: `url(/images/home_2/testimonial_bg.svg)` }}
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSectionStyle2
          sectionTitle="What Are the Benefits of <br /> Electronic Health Records?"
          sectionTitleUp="BENEFITS"
          data={testimonialData}
        />
      </Section> */}

            <Section
                topMd={185}
                topLg={140}
                topXl={100}
                bottomMd={0}
                bottomLg={0}
                bottomXl={0}
            >
                <HRSection
                    sectionTitle="Why Healthcare Institutions Need HRMS" />
            </Section>

            <WhyHRMSSection />


            <Section
                topMd={185}
                topLg={140}
                topXl={100}
                bottomMd={200}
                bottomLg={150}
                bottomXl={100}
                className="cs_gray_bg_1 cs_hr_feature_list"
            >
                <FeaturesSectionStyle5
                    sectionTitle="HRMS Module Overview"
                    data={featureListData}
                />
            </Section>
            <Section topMd={190} topLg={150} topXl={105} id="departments">
                <DepartmentSectionStyle6
                    sectionTitle="Efficiency, Accuracy & Transparency  Built Into Every Workflow"
                    sectionTitleUp="HRMS Key Benefits"
                    data={departmentData}
                />
            </Section>

            <Section bottomMd={190} bottomLg={145} bottomXl={105}>
                <AboutSectionStyle3
                    titleUp="Decades of expertise and market leadership. A distinguished history of 
          innovative Healthcare Solutions."
                    title="Meet The Minds Behind Medna Data Systems"
                    subTitle="Building compliant, scalable healthcare technology for the UAE.
Medna Data Systems is a healthcare technology company focused on delivering a robust, 
regulatory-ready Healthcare ERP and HMIS platform for clinics and hospitals operating in the UAE.
We bring together deep technical expertise, healthcare domain knowledge, and real-world implementation
 experience to solve one core problem: making healthcare operations simpler, compliant, and efficient
  without compromising patient data or clinical workflows."
                    imgUrl={about}
                />
            </Section>

            <Section
                topMd={185}
                topLg={140}
                topXl={100}
                bottomMd={200}
                bottomLg={150}
                bottomXl={110}
            >
                <BannerSectionStyle2
                    bgUrl={a23}
                    title="Don’t Let Your Hospital <br />Take a Backseat!"
                    subTitle="Schedule an demo with one of our experienced <br />professionals today!"
                />
            </Section>

            <Section>
                <AppointmentSectionStyle2
                    bgUrl={process.env.PUBLIC_URL + "/images/home_2/appointment_bg.svg"}
                    imgUrl={a2}
                    sectionTitle="Appointment"
                    sectionTitleUp="BOOK AN"
                />
            </Section>
            {/* <Section
                topMd={150}
                topLg={100}
                topXl={90}
                bottomMd={100}
                bottomLg={100}
                bottomXl={100}
            >
                <BrandsSectionStyle2 data={brandData} />
            </Section> */}
        </>
    );
}
